import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/components/LocaleProvider.tsx");
